// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_iy-0";
export var optionCard = "_iy-1";